import React from "react";

import { Link } from "react-router-dom";

import type { TerminationReason } from "src/clients/agent-management";
import { Callout } from "src/design-system/Callout";
import { DashboardPageParams, getUrlToSettingsPage } from "src/router/urls";
import { SettingsSubpages } from "src/settings/SettingsSubpages";
import { formatTerminationReason } from "src/utils/agents/formatTerminationReason";
import { useParamsDecode } from "src/utils/useParamsDecode";

type AgentFailedBannerProps = {
  terminationReason: TerminationReason | null;
  terminationMessage: string | null;
};

const QUOTA_TERMINATION_REASONS: TerminationReason[] = [
  "quota_exhausted",
  "rate_limit_exceeded",
];

export const AgentFailedBanner: React.FC<AgentFailedBannerProps> = ({
  terminationReason,
  terminationMessage,
}) => {
  const { orgId, wsId } = useParamsDecode<DashboardPageParams>();
  const showQuotaLink =
    terminationReason !== null &&
    QUOTA_TERMINATION_REASONS.includes(terminationReason) &&
    Boolean(orgId) &&
    Boolean(wsId);

  return (
    <div className="mt-4 flex-shrink-0">
      <Callout
        action={
          showQuotaLink ? (
            <Link
              to={getUrlToSettingsPage(
                orgId,
                wsId,
                SettingsSubpages.AiUsageLimits,
              )}
            >
              View AI usage limits
            </Link>
          ) : undefined
        }
        variant="error"
      >
        <div className="flex flex-col">
          <span className="font-inter-medium-12px">
            {terminationReason
              ? `Agent failed: ${formatTerminationReason(terminationReason)}`
              : "Agent failed"}
          </span>
          {terminationMessage && (
            <span className="font-inter-normal-12px">{terminationMessage}</span>
          )}
        </div>
      </Callout>
    </div>
  );
};
